import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Button } from '@beef/ui-kit';

import commonStyles from 'styles/common.pcss';
import { formatPrice, formatPhone } from 'utils/formatting';
import { Heading, PopupStateless, Preloader } from 'components';
import { IncludeContent } from 'bricks/IncludeContent';
import SPMessage from 'bricks/SPMessage';

import PickupBuyForm from '../PickupBuyForm';
import Coins from './assets/Coins.svg';
import Icon from './assets/icon.svg';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

/**
 * TODO: Rewrite this shitload, while holding back from suicide
 */
function ExplicitPickupBuyLayout({
  isMobile,
  /* isPreloading, */
  children,
  /* togglePickup,
  viewState,
  data,
  point, */
  headingText,
  /* useDescription,
  useTitle,
  subTitleText,
  useHeading,
  usePreload,
  explicitWrapper,
  explicitCenter, */
}) {
  return (
    <div className={cx('wrapper')}>
      <Heading
        tagName="div"
        level={isMobile ? 4 : 3}
        className={cx('heading', isMobile && 'mobile')}
      >
        {headingText}
      </Heading>
      {children}
    </div>
  );
}

ExplicitPickupBuyLayout.defaultProps = {
  /* explicitWrapper: true, */
};

ExplicitPickupBuyLayout.propTypes = {
  data: PropTypes.shape({
    headline: PropTypes.string,
    description: PropTypes.string,
    agreementContent: PropTypes.string,
    propsContent: PropTypes.string,
    buttonText: PropTypes.string,
  }),
  /* point: PropTypes.object,
  explicitCenter: PropTypes.bool,
  viewState: PropTypes.string,
  subTitleText: PropTypes.string,
  togglePickup: PropTypes.func, */
  isMobile: PropTypes.bool,
  /* isPreloading: PropTypes.bool, */
  children: PropTypes.node,
  /* useDescription: PropTypes.bool,
  useTitle: PropTypes.bool,
  usePreload: PropTypes.bool,
  useHeading: PropTypes.bool, */
  headingText: PropTypes.string,
  /* explicitWrapper: PropTypes.bool, */
};

export default function PickupBuyLayout({
  data,
  isOpen,
  togglePickup,
  setViewState,
  viewState,
  point,
  sendData,
  successData,
  isMobile,
  isLoading,
  isPointsLoading,
  errorDetails,
  finalHeader,
  finalText,
  children,
  hasEsim,
  spMessageText,
  spMessageButtonText,
  spMessageButtonUrl,
  reload,
}) {
  return (
    <PopupStateless
      opened={isOpen}
      isMobile={isMobile}
      onClose={() => {
        togglePickup(false, null, viewState);
        if (reload) {
          window.location.reload();
        }
      }}
    >
      {isLoading ?
        <div className={cx('loadLay', isMobile && 'mobile')}>
          <Preloader />
        </div>
      : null}
      {viewState === 'success' ?
        <ExplicitPickupBuyLayout
          isMobile={isMobile}
          togglePickup={togglePickup}
          viewState={viewState}
          data={data}
          point={point}
          headingText="Мы приняли ваш заказ"
          useHeading={isMobile}
          explicitWrapper={isMobile}
          useTitle={!isMobile}
          explicitCenter
        >
          {hasEsim ?
            <SPMessage
              messageText={spMessageText}
              buttonText={spMessageButtonText}
              url={spMessageButtonUrl}
            />
          : null}
          <div className={cx('rows', 'explicit', isMobile ? 'mobile' : null)}>
            {point?.onlyCard ?
              <div className={cx('onlyCardThankTitle')}>
                <div>{point.onlyCardThankYouTitle}</div>
              </div>
            : null}
            <div className={cx('row', 'explicit', isMobile ? 'rowMobile' : null)}>
              <div className={cx('type')}>Номер заказа</div>
              <div className={cx('value', 'explicit', isMobile && 'mobile')}>
                {successData.orderId}
              </div>
            </div>
            <div className={cx('row', 'explicit', isMobile ? 'rowMobile' : null)}>
              <div className={cx('type')}>Вы приобретаете</div>
              <div className={cx('value', 'explicit', isMobile && 'mobile')}>
                {successData.title}
                <br /> 1 шт.
                <div className={cx('valueBig')}>{formatPrice(successData.price)} ₽</div>
              </div>
            </div>
            <div className={cx('row', 'explicit', isMobile ? 'rowMobile' : null)}>
              <div className={cx('type')}>Контактная информация</div>
              <div className={cx('value', 'explicit', isMobile && 'mobile')}>
                {successData.name}
                <br />
                {formatPhone(successData.phone)}
                {successData.email && `, ${successData.email}`}
              </div>
            </div>
            <div className={cx('row', 'explicit', isMobile ? 'rowMobile' : null)}>
              <div className={cx('type')}>Место получения</div>
              <div className={cx('value', 'explicit', isMobile && 'mobile')}>
                {successData.header} по адресу:
                <br />
                {successData.pointAddress}
                <br />
                {successData.pointOpening}
              </div>
            </div>
          </div>
          <div className={cx('message', 'explicit', isMobile && 'mobile' && 'mobileInfoText')}>
            <span className={cx('successInfo')}>
              Пожалуйста, дождитесь звонка нашего оператора или SMS с кодом подтверждения заказа.
              Заказ можно получить в выбранном салоне-магазине. Если у вас возникли вопросы по
              поводу вашего заказа, позвоните нам по телефону
              <p className={cx('phoneNumber')}>8-800-725-57-25.</p>
            </span>
            <span className={cx('thanksMessage')}>Благодарим вас за то, что выбрали Билайн!</span>
          </div>
          {finalHeader && finalHeader.length !== 0 && finalText ?
            <div
              className={cx('device_plus_done_wrapper', 'explicit', isMobile ? 'rowMobile' : null)}
            >
              <span className={cx('device_plus_done_headline', isMobile ? 'rowMobile' : null)}>
                {finalHeader}
                <Coins className={cx('device_plus_icon', isMobile ? 'rowMobile' : null)} />
              </span>
              <div className={cx('device_plus_content', isMobile ? 'rowMobile' : null)}>
                <IncludeContent className={cx('padb-s')} htmlContent={finalText} />
              </div>
            </div>
          : null}
          <div className={cx('buttonWrap', 'explicit', isMobile && 'mobile')}>
            <Button
              fullWidth={isMobile}
              className={isMobile ? 'null' : 'big'}
              onClick={() => {
                togglePickup(false, null);
                window.location.href = '/shop/catalog/telefony/smartfony/';
              }}
              variant="tertiary"
            >
              Вернуться к покупкам
            </Button>
          </div>
        </ExplicitPickupBuyLayout>
      : null}

      {viewState === 'form' ?
        <ExplicitPickupBuyLayout
          isMobile={isMobile}
          togglePickup={togglePickup}
          viewState={viewState}
          data={data}
          point={point}
          explicitCenter
          headingText="На кого оформить заказ?"
          useDescription
          useHeading
        >
          {point && point.onlyCard && (
            <div className={cx('card', isMobile && 'mobile')}>
              <Icon /> <span className={cx('text')}>{point.onlyCardTitle}</span>
            </div>
          )}
          <PickupBuyForm
            className={cx('form')}
            isMobile={isMobile}
            buttonText={data.buttonText}
            onClick={(info) => {
              sendData(info);
            }}
            explicitCenter
          />
          <div className={cx('notice', 'explicit', isMobile && 'mobile')}>
            Подтверждая заказ, вы соглашаетесь с
            <span
              className={cx('anchor', 'explicit')}
              onClick={() => {
                setViewState('props');
              }}
              role="button"
              tabIndex={0}
            >
              Условиями продажи
            </span>{' '}
            в интернет-магазине ПАО «ВымпелКом» и
            <span
              className={cx('anchor', 'explicit')}
              onClick={() => {
                setViewState('agreement');
              }}
              role="button"
              tabIndex={0}
            >
              Согласием на обработку персональных данных
            </span>
            .
          </div>
        </ExplicitPickupBuyLayout>
      : null}
      {viewState === 'map' ?
        <ExplicitPickupBuyLayout
          isMobile={isMobile}
          isPreloading={isPointsLoading}
          togglePickup={togglePickup}
          viewState={viewState}
          data={data}
          point={point}
          headingText="Выберите удобный вам пункт выдачи"
          subTitleText="Доставим бесплатно при сумме заказа от 3 000 ₽"
          useHeading
          usePreload
        >
          {children}
        </ExplicitPickupBuyLayout>
      : null}

      {viewState === 'props' ?
        <ExplicitPickupBuyLayout
          isMobile={isMobile}
          togglePickup={togglePickup}
          viewState={viewState}
          data={data}
          point={point}
          headingText="Условия продажи товаров в Интернет-магазине:"
          useHeading={isMobile}
          explicitWrapper={isMobile}
          useTitle={!isMobile}
        >
          <div className={cx('contentBlock', isMobile && 'mobile')}>
            <IncludeContent className={cx('padb-s')} htmlContent={data.propsContent} />
          </div>
          <div className={cx(isMobile && 'mobileButton')}>
            <Button
              className={isMobile ? null : 'big'}
              onClick={() => {
                setViewState('form');
              }}
              wide={isMobile}
            >
              Вернуться к оформлению
            </Button>
          </div>
        </ExplicitPickupBuyLayout>
      : null}

      {viewState === 'agreement' ?
        <ExplicitPickupBuyLayout
          isMobile={isMobile}
          togglePickup={togglePickup}
          viewState={viewState}
          data={data}
          point={point}
          headingText="Согласие на обработку персональных данных"
          useHeading={isMobile}
          explicitWrapper={isMobile}
          useTitle={!isMobile}
        >
          <div className={cx('contentBlock', isMobile && 'mobile')}>
            <IncludeContent className={cx('padb-s')} htmlContent={data.agreementContent} />
          </div>
          <div className={cx(isMobile && 'mobileButton')}>
            <Button
              className={isMobile ? null : 'big'}
              onClick={() => {
                setViewState('form');
              }}
              wide={isMobile}
            >
              Вернуться к оформлению
            </Button>
          </div>
        </ExplicitPickupBuyLayout>
      : null}

      {viewState === 'error' ?
        <ExplicitPickupBuyLayout
          isMobile={isMobile}
          togglePickup={togglePickup}
          viewState={viewState}
          data={data}
          point={point}
          headingText={errorDetails.headline ? errorDetails.headline : 'Произошла ошибка'}
          useHeading={isMobile}
          explicitWrapper={isMobile}
          useTitle={!isMobile}
        >
          <div className={cx('message', 'explicit', isMobile && 'mobile')}>
            {!errorDetails.message ? 'Неизвестная ошибка' : errorDetails.message}
          </div>
        </ExplicitPickupBuyLayout>
      : null}
    </PopupStateless>
  );
}

PickupBuyLayout.defaultProps = {
  isPointsLoading: false,
};

PickupBuyLayout.propTypes = {
  data: PropTypes.shape({
    headline: PropTypes.string,
    description: PropTypes.string,
    agreementContent: PropTypes.string,
    propsContent: PropTypes.string,
    buttonText: PropTypes.string,
  }),
  point: PropTypes.object,
  reload: PropTypes.bool,
  isOpen: PropTypes.bool,
  togglePickup: PropTypes.func,
  sendData: PropTypes.func,
  setViewState: PropTypes.func,
  viewState: PropTypes.string,
  successData: PropTypes.shape({
    delivery: PropTypes.object,
    client: PropTypes.object,
    cartItems: PropTypes.array,
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    orderId: PropTypes.string,
    price: PropTypes.number,
    title: PropTypes.string,
    pointAddress: PropTypes.string,
    pointOpening: PropTypes.string,
    header: PropTypes.string,
  }),
  isMobile: PropTypes.bool,
  isLoading: PropTypes.bool,
  isPointsLoading: PropTypes.bool,
  errorDetails: PropTypes.shape({
    headline: PropTypes.string,
    message: PropTypes.string,
  }),
  finalHeader: PropTypes.any,
  finalText: PropTypes.any,
  children: PropTypes.node,
  hasEsim: PropTypes.bool,
  spMessageText: PropTypes.string,
  spMessageButtonText: PropTypes.string,
  spMessageButtonUrl: PropTypes.string,
};
